// Angular
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from "@angular/core";
import { provideClientHydration, withEventReplay } from "@angular/platform-browser";
import {
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling,
} from "@angular/router";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { registerLocaleData } from "@angular/common";
import { FormsModule } from "@angular/forms";
import en from "@angular/common/locales/en";

// Antd
import { provideNzIcons } from "ng-zorro-antd/icon";
import { provideNzI18n, en_US } from "ng-zorro-antd/i18n";

// Other
import { httpRequestInterceptor } from "#src/app/core/interceptors/http.interceptor";
import { routes } from "#src/app/app.routes";
import { icons } from "#src/app/icons-provider";

registerLocaleData(en);

export const appConfig: ApplicationConfig = {
    providers: [
        provideNzI18n(en_US),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideClientHydration(withEventReplay()),
        provideNzIcons(icons),
        importProvidersFrom(FormsModule),
        provideHttpClient(withFetch(), withInterceptors([httpRequestInterceptor])),
        provideRouter(
            routes,
            withEnabledBlockingInitialNavigation(),
            withInMemoryScrolling({ scrollPositionRestoration: "top" })
        ),
    ],
};
